import { ruleBundleMaint } from "./rules/rule-bundle-maint";
import { ruleCanPrint } from "./rules/rule-can-print";
import { ruleIsAdmin } from "./rules/rule-is-admin";
import { ruleIsTester } from "./rules/rule-is-tester";
import { ruleIsUser } from "./rules/rule-is-user";
import { ruleIsViewer } from "./rules/rule-is-viewer";
import { ruleMaintainProfiles } from "./rules/rule-maintain-profiles";
import { ruleNeverAssigned } from "./rules/rule-never-assigned";
import { ruleReports } from "./rules/rule-reports";
import { ruleSayHello } from "./rules/rule-say-hello";

export const getRules = () => {
  return {
    sayHello: ruleSayHello(),
    canPrint: ruleCanPrint(),
    isUser: ruleIsUser(),
    isViewer: ruleIsViewer(),
    maintainProfiles: ruleMaintainProfiles(),
    isTester: ruleIsTester(),
    isAdmin: ruleIsAdmin(),
    bundleMaint: ruleBundleMaint(),
    reports: ruleReports(),
    never: ruleNeverAssigned(),
  };
};
